import TopHeadScreen from "../../component/layout/tophead";
import SidebarScreen from "../../component/layout/sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import Button from "react-bootstrap/Button";
import { HiOutlineLightBulb } from "react-icons/hi";
import { FaCheck } from "react-icons/fa6";
import { LiaAwardSolid } from "react-icons/lia";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import AddAchievementModal from "./common/add-achievement-modal";
import { useState } from "react";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import { AppRoute } from "../../router/routerConstants";
import AgentSidebarScreen from "../../component/layout/agent-sidebar";
import AgentTopHeadScreen from "../../component/layout/agent-header";
import { LuPencilLine } from "react-icons/lu";
const ResumeAfterAddedAchivementsInformationScreen = () => {
  const { resumeDetails } = useSelector(
    (state: RootState) => state?.resumeSlice
  );
  const { user } = useSelector((state: RootState) => state.authSlice);
  const [showWork, setShowWork] = useState(false);
  const handleCloseWK = () => setShowWork(false);
  const handleShowWK = () => setShowWork(true);
  const [NavigateTo] = useCustomNavigate();

  const nextHandler = () => {
    if (user && user?.role === "jobseeker") {
      if (resumeDetails?.skills && resumeDetails?.skills?.length > 0)
        NavigateTo(AppRoute.JOBSEEKER_AFTER_ADDED_QUALIFICATIONS);
      else NavigateTo(AppRoute.JOBSEEKER_QUALIFICATIONS);
    } else if (user && user?.role === "localagents") {
      if (resumeDetails?.skills && resumeDetails?.skills?.length > 0)
        NavigateTo(AppRoute.AGENT_AFTER_ADDED_QUALIFICATIONS);
      else NavigateTo(AppRoute.AGENT_QUALIFICATIONS);
    }
  };
  const prevHandler = () => {
    if (user && user?.role === "jobseeker") {
      if (resumeDetails?.educations && resumeDetails?.educations?.length > 0)
        NavigateTo(AppRoute.JOBSEEKER_AFTER_ADDED_EDUCATION);
      else NavigateTo(AppRoute.JOBSEEKER_EDUCATION);
    } else if (user && user?.role === "localagents") {
      if (resumeDetails?.educations && resumeDetails?.educations?.length > 0)
        NavigateTo(AppRoute.AGENT_AFTER_ADDED_EDUCATION);
      else NavigateTo(AppRoute.AGENT_EDUCATION);
    }
  };
  return (
    <>
      <div className="main">
        <section className="profileJobDetails-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar  position-relative p-0">
                {user && user?.role === "jobseeker" && <SidebarScreen />}
                {user && user?.role === "localagents" && (
                  <AgentSidebarScreen />
                )}{" "}
              </div>
              <div className="col-lg-10 rightcontent p-0">
                {user && user?.role === "jobseeker" && <TopHeadScreen />}
                {user && user?.role === "localagents" && (
                  <AgentTopHeadScreen />
                )}{" "}
                <div className="profile-account-details-holder rightInnerScroll common-padd-lt-rt ">
                  <div className="row">
                    <div className="col-lg-12 mb-4">
                      <div className="profile-account-details">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="title">
                              <h2>My Resume</h2>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="myResume-holder">
                              <div className="login-form-area add-password-form mt-5">
                                <div className="stepbar">
                                  <ul>
                                    <li className="checked">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <FaCheck />
                                          </span>
                                        </div>
                                        <p>Step 1</p>
                                        <h4>About You</h4>
                                      </a>
                                    </li>
                                    <li className="checked">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <FaCheck />
                                          </span>
                                        </div>
                                        <p>Step 2</p>
                                        <h4>Experience</h4>
                                      </a>
                                    </li>
                                    <li className="checked">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <FaCheck />
                                          </span>
                                        </div>
                                        <p>Step 3</p>
                                        <h4>Education</h4>
                                      </a>
                                    </li>
                                    <li className="inprogress">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <LiaAwardSolid />
                                          </span>
                                        </div>
                                        <p>Step 4</p>
                                        <h4>Achievements</h4>
                                      </a>
                                    </li>
                                    <li className="">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <HiOutlineLightBulb />
                                          </span>
                                        </div>
                                        <p>Step 5</p>
                                        <h4>Skills</h4>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>

                              <div className="comnbrdrGap profileEdit mb-4">
                                <div className="d-flex">
                                  <h3>My Achievements</h3>
                                  <button
                                    className="editbtn"
                                    onClick={handleShowWK}
                                  >
                                    <LuPencilLine /> Edit
                                  </button>
                                </div>
                                <ul className="rightliarrow">
                                  {resumeDetails?.achievements &&
                                    resumeDetails?.achievements?.map(
                                      (item: any, index: number) => {
                                        return (
                                          <div key={index}>
                                            <li>{item}</li>
                                          </div>
                                        );
                                      }
                                    )}
                                </ul>
                              </div>
                              <div className="flex-btn d-flex">
                                <Button
                                  className="btn btn-primary"
                                  onClick={prevHandler}
                                >
                                  Prev
                                </Button>
                                <Button
                                  className="btn btn-primary"
                                  onClick={nextHandler}
                                >
                                  Next
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />
      <AddAchievementModal
        show={showWork}
        onClose={handleCloseWK}
        isEdit={true}
      />
    </>
  );
};
export default ResumeAfterAddedAchivementsInformationScreen;
